<div class="app-container">
  <app-loading></app-loading>
  <router-outlet></router-outlet>
</div>